import { Box, Step, StepIcon, StepIndicator, StepNumber, StepSeparator, StepStatus } from '@chakra-ui/react';
import React from 'react';

const StepLayout = ({ children, isLocked }: { children: JSX.Element | JSX.Element[]; isLocked?: boolean }) => {
	return (
		<Step style={{ width: '100%', gap: '10px' }}>
			<Box position="relative" sx={{ '--stepper-indicator-size': '24px' }}>
				<StepIndicator boxSize="24px" border="none">
					<StepStatus complete={<StepCompleteIcon />} incomplete={<StepInCompleteIcon locked={isLocked} />} active={<StepInCompleteIcon />} />
				</StepIndicator>
				{/*******************  Dashed Border *******************/}
				<Box
					as={StepSeparator}
					position="absolute"
					maxH="calc(100% - var(--stepper-indicator-size)) !important"
					w="1px"
					top="var(--stepper-indicator-size) !important"
					background="none !important"
					border="1px dashed #6698FA"
				/>
			</Box>

			<Box w="full" pb="14px">
				{children}
			</Box>
		</Step>
	);
};

export default StepLayout;

const StepCompleteIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="12" r="12" fill="#6FCD9E" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.3657 8.23423C17.5157 8.38425 17.5999 8.5877 17.5999 8.79983C17.5999 9.01196 17.5157 9.21541 17.3657 9.36543L10.9657 15.7654C10.8157 15.9154 10.6122 15.9997 10.4001 15.9997C10.188 15.9997 9.9845 15.9154 9.83448 15.7654L6.63448 12.5654C6.48876 12.4145 6.40812 12.2125 6.40994 12.0027C6.41177 11.793 6.4959 11.5923 6.64423 11.444C6.79255 11.2956 6.9932 11.2115 7.20296 11.2097C7.41272 11.2079 7.6148 11.2885 7.76568 11.4342L10.4001 14.0686L16.2345 8.23423C16.3845 8.08425 16.588 8 16.8001 8C17.0122 8 17.2157 8.08425 17.3657 8.23423Z"
				fill="white"
			/>
		</svg>
	);
};

const StepInCompleteIcon = ({ locked = false }: { locked?: boolean }) => {
	return locked ? (
		<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="13" cy="13" r="12.5" fill="white" stroke="#D6E2FA" />
			<path
				d="M8.9999 12.9496H9.7499V12.1996V10.5996C9.7499 9.73766 10.0923 8.91101 10.7018 8.30151C11.3113 7.69202 12.1379 7.34961 12.9999 7.34961C13.8619 7.34961 14.6885 7.69202 15.298 8.30151L15.8283 7.77118L15.298 8.30151C15.9075 8.91101 16.2499 9.73766 16.2499 10.5996V12.1996V12.9496H16.9999C17.2253 12.9496 17.4415 13.0392 17.6009 13.1986C17.7603 13.358 17.8499 13.5742 17.8499 13.7996V17.7996C17.8499 18.025 17.7603 18.2412 17.6009 18.4006C17.4415 18.5601 17.2253 18.6496 16.9999 18.6496H8.9999C8.77447 18.6496 8.55827 18.5601 8.39886 18.4006L7.86853 18.931L8.39886 18.4006C8.23946 18.2412 8.1499 18.025 8.1499 17.7996V13.7996C8.1499 13.5742 8.23946 13.358 8.39886 13.1986C8.55827 13.0392 8.77447 12.9496 8.9999 12.9496ZM16.1499 12.9496V12.1996V10.5996C16.1499 9.76418 15.818 8.96296 15.2273 8.37222C14.6366 7.78148 13.8353 7.44961 12.9999 7.44961C12.1645 7.44961 11.3633 7.78148 10.7725 8.37222C10.1818 8.96296 9.8499 9.76418 9.8499 10.5996V12.1996V12.9496H10.5999H15.3999H16.1499Z"
				fill="#4358F6"
				stroke="#4358F6"
				strokeWidth="1.5"
			/>
		</svg>
	) : (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="12" r="12" fill="#4358F6" />
			<circle cx="12" cy="12" r="6" fill="#F2F7FF" />
		</svg>
	);
};
